import { useEffect, useRef } from 'react';

export const useInterval = (
  condition: boolean,
  onInterval: () => void,
  intervalDuration: number,
) => {
  const interval = useRef<null | NodeJS.Timeout>(null);

  useEffect(() => {
    const start = () => {
      interval.current = setInterval(() => {
        onInterval();
      }, intervalDuration);
    };

    const stop = () => {
      if (interval.current !== null) {
        clearInterval(interval.current);
        interval.current = null;
      }
    };

    if (condition) {
      start();
    } else {
      stop();
    }

    return () => {
      stop();
    };
  }, [condition, onInterval, intervalDuration]);
};
